var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.schema.items != null)?_c('span',[_vm._l((_vm.schema.items),function(sc,index){return [_c('t-widget',{key:index,attrs:{"schema":sc,"data":_vm.data},on:{"input":_vm.simpleEmit}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }